import './title-panel.styles.scss';
interface TitlePanelProps {
  title: string,
  panelBody: any
}
const TitlePanel = (props: TitlePanelProps) => {

  return <div className="title-panel">
    <div className="panel-title">{props.title}</div>
    <div className="panel-body">
      {props.panelBody}
    </div>
  </div>
}

export default TitlePanel;